var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYtDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7626 11.575C36.5634 10.8351 36.1734 10.1604 35.6315 9.61854C35.0897 9.0767 34.415 8.68667 33.6751 8.4875C30.9501 7.75 20.0001 7.75 20.0001 7.75C20.0001 7.75 9.05006 7.75 6.32506 8.4875C5.58511 8.68667 4.91045 9.0767 4.36861 9.61854C3.82676 10.1604 3.43673 10.8351 3.23756 11.575C2.72779 14.354 2.48087 17.1747 2.50006 20C2.48087 22.8253 2.72779 25.646 3.23756 28.425C3.43673 29.165 3.82676 29.8396 4.36861 30.3815C4.91045 30.9233 5.58511 31.3133 6.32506 31.5125C9.05006 32.25 20.0001 32.25 20.0001 32.25C20.0001 32.25 30.9501 32.25 33.6751 31.5125C34.415 31.3133 35.0897 30.9233 35.6315 30.3815C36.1734 29.8396 36.5634 29.165 36.7626 28.425C37.2723 25.646 37.5193 22.8253 37.5001 20C37.5193 17.1747 37.2723 14.354 36.7626 11.575ZM16.5001 25.25V14.75L25.5876 20L16.5001 25.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYtDark);
export default __webpack_public_path__ + "static/media/ic-yt-dark.4a82a373fe233fb650c991c57544f416.svg";
export { ForwardRef as ReactComponent };